import {
    Grid,
    Avatar,
    Box,
    Button,
    Dialog,
    Slide,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TextField,
    Tab,
    touchRippleClasses,
} from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import pr from "../lib/pr";
import axios from "axios";
import { loginState, configState } from "../lib/State";
import get_token from "../lib/get_token";
import get_cid from '../lib/get_cid';
import { ReactComponent as PTIcon } from '../assets/pt_back.svg';
import { ReactComponent as BonusIcon } from '../assets/bonus_back.svg';


function MypageLoggedCouponPT(props) {
    const { login } = props;
    const [rows, setRows] = useState([]);
    const history = useHistory();
    const token = get_token();
    const cid = get_cid();

    const onGoBookClick = (event) => {
        // history.push("/book?coupon_seq=" + event.target.value);
    };

    const load_data = async () => {
        pr("load_data");
        let result = await axios.post(configState.api + "/gympass/my_coupon_pt", {
            token: token,
            cid: cid,
            mcd: login.mcd,
            level: login.level,
        });
        setRows(result.data.rows);
    };
    useEffect(() => {
        load_data();
    }, []);
    return (
        <>
            {
                // 쿠폰이 없을 때
                rows.length === 0 && (
                    <>
                        <Box sx={{ width: "100%", textAlign: "center", fontSize: 14 }}>
                            사용 가능한 쿠폰이 없습니다.
                        </Box>
                    </>
                )
            }
            <>
                {/* 쿠폰이 있을 때 */}
                {rows.map((item, index) => {
                    const remain_count =
                        item.total_count + 0 - (item.use_count + 0);
                    let is_available = false;
                    const today = moment().format("YYYY.MM.DD");
                    const enroll_sdate = moment(item.enroll_sdate).format('YYYY.MM.DD'); // 시작일
                    const enroll_edate = moment(item.enroll_edate).format(
                        "YYYY.MM.DD"
                    ); // 만료일

                    let gubun = item.pt_type;
                    if(gubun === 'PT_MANAGER') {
                        gubun = 'PT점장'
                    }
                    if(gubun === 'PT_TRAINER') {
                        gubun = 'PT트레이너'
                    }
                    
                    return (
                        <Grid
                            container
                            display="flex"
                            width="100%"
                            justifyContent="center"
                            alignItems="center"
                            key={index}
                            // sx={{
                            //     marginBottom: '10px'
                            // }}
                        >
                            <>
                            <Box
                                sx={{
                                    width: '90%',
                                    position: 'relative',
                                }}>
                                {item.is_bonus === 'Y' ? <BonusIcon width='100%' /> : <PTIcon width='100%' />}
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        left: '30%',
                                        top: '45%',
                                        transform: 'translateY(-45%)',
                                        marginLeft: '10px',
                                        color: 'white',
                                    }}>
                                    <Box
                                        sx={{
                                            fontSize: '13px',
                                            marginRight: '10px',
                                            fontWeight: 'bold',
                                            letterSpacing: '-1px',
                                        }}>
                                        <Box>
                                            {item.coupon_name}
                                        </Box>
                                        <Box>
                                            {enroll_sdate} ~ {enroll_edate}
                                        </Box>
                                    </Box>
                                </Box>
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        right: '10%',
                                        top: '45%',
                                        transform: 'translateY(-45%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        fontWeight: 'bold',
                                        marginLeft: '8px',
                                        color: 'white'
                                    }}>
                                    <Box
                                        sx={{
                                            fontSize: 21
                                        }}>
                                        {remain_count}
                                    </Box>
                                </Box>
                            </Box>
                            </>
                        </Grid>
                    );
                })}
                <Box sx={{ width: '100%', height: '80px' }}></Box>
            </>
        </>
    )
};

export default MypageLoggedCouponPT;